module.exports = __webpack_public_path__ + "img/328843303_1313794922498379_8648968739419468982_n.385506cc.jpg";